import { lazy, Suspense } from 'react';
import { useSession } from '@/shared/auth';
import { RouteFallback } from './RouteFallback';

const PublicSheetViewer = lazy(() => import('@/modules/sheets/PublicSheetViewer').then((module) => ({ default: module.PublicSheetViewer })));
const SheetEditor = lazy(() => import('@/modules/sheets/SheetEditor').then((module) => ({ default: module.SheetEditor })));

export function PublicSheetRoute() {
  const { status } = useSession();
  return <Suspense fallback={<RouteFallback />}>{status === 'signedOut' ? <PublicSheetViewer /> : <SheetEditor />}</Suspense>;
}
